// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"00e51d5b","399":"57102478","573":"9ac562b9","588":"00d7e667","683":"d11bcce3","784":"61f00911","787":"bed44058"}[chunkId] + ".chunk.js";
};